import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import type { Color } from "@msuite/utils/colors";
import type { MailboxListItem } from "@msuite/utils/types";

/** Props Interface */
interface MailboxHealthTagProps {
	mailbox: Pick<MailboxListItem, "health" | "isPaused">;
}

const HEALTH_COLOR: Record<MailboxListItem["health"], Color> = {
	ok: "emerald",
	failing: "amber",
	"needs-attention": "rose",
};

export function MailboxHealthTag({ mailbox }: MailboxHealthTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	if (mailbox.isPaused) {
		return (
			<Tag
				color="gray"
				variant="plain"
			>
				{t("mailboxes.is_paused")}
			</Tag>
		);
	}
	const key = mailbox.health === "needs-attention" ? "needs_attention" : mailbox.health;
	return (
		<Tag
			color={HEALTH_COLOR[mailbox.health]}
			variant="plain"
		>
			{t(`mailboxes.health_state.${key}`)}
		</Tag>
	);
}
